import React, { PureComponent } from 'react'
import { string, oneOf } from 'prop-types'
import { TableCell } from './TableCell'

export class HealthTableCell extends PureComponent {
    static propTypes = {
        health: oneOf(['GOOD', 'MEDIUM', 'CRITICAL', 'BROKEN']).isRequired,
        children: string.isRequired
    }

    render() {
        const { health, children, ...otherProps } = this.props
        return <TableCell className={['Health', health]} {...otherProps}>{children}</TableCell>
    }
}



// WEBPACK FOOTER //
// src/components/Table/HealthTableCell.js